import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgPin3 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M12 1.5c-3.655 0-5.817 1.449-7.041 3.285C3.757 6.588 3.5 8.7 3.5 10c0 3.348 1.397 6.081 3.115 8.156 1.715 2.072 3.768 3.508 5.14 4.28a.5.5 0 0 0 .49 0c1.372-.772 3.425-2.208 5.14-4.28C19.103 16.081 20.5 13.348 20.5 10c0-1.3-.257-3.412-1.459-5.215C17.817 2.95 15.655 1.5 12 1.5M15 9q0 3-3 3T9 9t3-3 3 3'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgPin3)
export default ForwardRef
